# generate an object from an array
#
# @params [Array] values the array array to generate an object from
# @params [any] defaultValue the defaultValue to assign to each index of the array
# in the object
#
genObjFromArray = (values, defaultValue=1) ->
    obj = {}
    obj[val] = defaultValue for val in values
    obj

# NOTE: when Object.assign is supported in all browsers, use that instead of
# this function
copyObject = (obj) ->
    newObj = {}

    for key, val of obj
        newObj[key] = val

    newObj

# generate a union of objects
#
# @params [Array] objectList a list of object to form a union. NOTE: if an
# object has the same keys then the last object listed in objectList's key
# will be used.
#
genObjectUnion = (objectList) ->
    newObject = {}
    for object in objectList
        newObject[k] = v for k, v of object

    newObject

module.exports = {
    genObjFromArray: genObjFromArray,
    copyObject: copyObject,
    genObjectUnion: genObjectUnion
}


// WEBPACK FOOTER //
// ./node_modules/musecoreui/util/object_util.coffee